import { render, staticRenderFns } from "./SemesterDetail.vue?vue&type=template&id=27e3ec80&scoped=true"
import script from "./SemesterDetail.vue?vue&type=script&lang=js"
export * from "./SemesterDetail.vue?vue&type=script&lang=js"
import style0 from "./SemesterDetail.vue?vue&type=style&index=0&id=27e3ec80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e3ec80",
  null
  
)

export default component.exports